/*
* 状态对象
* */

export default {
  indexBlockList: [],
  // marketInfo: [],
  indexTxnList: [],
  blockInfo: {},
  blockDetail: {},

  txnInfo: {},
  txnDetail: {},

  accountInfo: {},
  accountDetail: {},
  accountTxnInfo: {},

}



// WEBPACK FOOTER //
// ./src/store/state.js